<template>
  <v-container>
    <v-data-table
      :headers="columns"
      :items="rows"
    >
      <template v-slot:item.invoice.dueDate="{ item }">
        {{ formatDate(item.invoice.dueDate) }}
      </template>
      <template v-slot:item.pay="{ item }">
        <v-icon style="margin-right: 5px" :disabled="item.payed" @click="buy(item)">
          mdi-shopping
        </v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>

import ApiRepository from "@/repositories/ApiRepository";
import moment from "moment";
import Hash from "object-hash";
import SmartRepository from "@/repositories/SmartRepository";
import Constants from "../../constants";

export default {
    data: () => {
        return {
            columns: [
                { text: 'Name', align: 'center', value: 'name', },
                { text: 'Date', align: 'left', value: 'invoice.dueDate',  },
                { text: 'Price', align: 'center', value: 'initialAmount',  sortable: true},
                { text: 'Outstanding', align: 'center', value: 'outstandingAmount',  sortable: true},
                { text: 'Pay', align: 'center', value: 'pay'}
            ],
            rows: [],
        };
    },
    created () {
    },
    mounted () {
        this.fetch();
    },
    methods: {
        row_classes (item) {
            if (item.payed) {
                return "green";
            }
        },
        fetch () {
            ApiRepository.getMarketItems()
                .then((res) => {
                    this.rows = res.data.items;
                    for (const row of this.rows) {
                        const mySTR = row.factoring._id.toString();
                        const hash = '0x' + Hash.sha1(mySTR);
                        SmartRepository.call(Constants.contractMarketplace, "getOutstandingAmount", [hash])
                            .then((res) => {
                                row.outstandingAmount = SmartRepository.decodeEther(res);
                            })
                            .catch((err) => {
                            });
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        formatDate (date) {
            return moment(date).format('MMM D, YYYY' );
        },
        buy (item) {
            const mySTR = item.factoring._id.toString();
            const hash = '0x' + Hash.sha1(mySTR);
            SmartRepository.call(Constants.contractMarketplace, "getOutstandingAmount", [hash])
                .then((res) => {
                    this.$root.$emit('show-payment-modal', {
                        title: this.$t('Add liquidity'),
                        message: this.$t('Message Add Liquidity'),
                        maxAmmount: SmartRepository.decodeEther(res),
                        factoringId: item.factoring._id,
                        yes: () => {
                            // fer refresh
                            this.fetch();
                        }
                    });
                })
                .catch((err) => {
                });
        }
    },
};

</script>
<style>

</style>
